import React from 'react';
import { CampaignsTable } from './CampaignsTable';

export const CampaignsList: React.FC = () => {
  return <CampaignsTable />;
};
